<template>
  <v-alert
    v-if="enabled"
    type="info"
    variant="tonal"
    density="compact"
    icon="mdi-history"
    class="historique-banner mb-3"
  >
    <template v-if="mode === 'annee' && anneeUniversitaire">
      Mode historique — année <strong>{{ anneeUniversitaire }}</strong>
      + sessions prévues / en cours.
    </template>
    <template v-else>
      Mode historique activé — toutes les années (sessions terminées et annulées incluses).
    </template>
  </v-alert>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useHistoriqueMode, type HistoriqueModeKind } from '@/composables/useHistoriqueMode'

const props = defineProps<{
  enabled?: boolean
}>()

const { enabled: ctxEnabled, mode: ctxMode, anneeUniversitaire: ctxAnnee } = useHistoriqueMode()

const enabled = computed(() => props.enabled ?? ctxEnabled.value)
const mode = computed<HistoriqueModeKind>(() => ctxMode.value)
const anneeUniversitaire = computed(() => ctxAnnee.value)
</script>

<style scoped>
.historique-banner {
  font-size: 0.9rem;
}
</style>
